import Env from '../base/env';
import Component from 'gia/Component';
import { RevealFadeOut } from '../fx/Common'

export default class FxModule extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    //? Fns
    setTimeout(() => {
      RevealFadeOut(this.DOM.view)
    }, Env.timingDelayFx);
  }
}
